import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";

import PageConverterPage from "../Converter/PageConverterPage";

import ComponentsViewer from "../Pages/ComponentsViewer";
import RegisterCandidate from "../Pages/RegisterCandidate";
import RegisterCandidateBiography from "../Pages/RegisterCandidateBiography";
 
const NotFound = () => {
  const location = useLocation();

  return (
    <div
      style={{
        padding: "2rem",
        textAlign: "center",
        minHeight: "50vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <h1>404 - Page Not Found</h1>
      <p>The page "{location.pathname}" does not exist.</p>
      <button
        onClick={() => window.history.back()}
        style={{
          padding: "0.5rem 1rem",
          backgroundColor: "rgba(96,19,80,1)",
          color: "white",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
          marginTop: "1rem",
        }}
      >
        Go Back
      </button>
    </div>
  );
};

const AllRoutes = ({ showToolbar }) => {
  return (
    <Routes>
      <Route
        path="/"
        element={<PageConverterPage showToolbar={showToolbar} />}
      />

      <Route
        path="/PageViewer"
        element={<PageConverterPage showToolbar={showToolbar} />}
      />

      <Route path="/ComponentList" element={<ComponentsViewer />} />
      <Route path="*" element={<NotFound />} />
        <Route path="/RegisterCandidate" element={<RegisterCandidate />} />
    {/* <Route path="/RegisterClientErrorPasswordmatch" element={<RegisterClientErrorPasswordmatch />} /> */}
    <Route path="/RegisterCandidateBiography" element={<RegisterCandidateBiography />} />
</Routes>
  );
};

export default AllRoutes;
